import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { PageUserInforPresenter } from './ui-commons/presenter/page_userinfo.presentert';
import { IBillingInfo, PaymentBusEventsService } from '../../services/payment.busevents.service';
import { UICardContainerComponent } from "../../../../shared/ui-commons/ui-card-page/ui-card-page.components";
import { ReactiveFormsModule } from "@angular/forms";

@Component({
  selector: 'cv-page-info-billing',
  templateUrl: './page-info-billing.component.html',
  imports: [
    UICardContainerComponent,
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageInfoBillingComponent {

  public puip = new PageUserInforPresenter();

  private readonly pbes = inject(PaymentBusEventsService);

  actionAccept(): void {
    if (this.puip.isFormValid()) {
      this.pbes.sendEvent({
        code: 'OPEN_GATEWAY_IZIPAY',
        description: 'STORE_INFO_BILLING',
        infoBilling: this.puip.getFormData() as IBillingInfo,
      });
    } else {
      this.puip.markAsTouched();
    }
  }
}
